export class PollingError extends Error {
  name = 'PollingError';
  statusCode?: number;
  payload?: unknown;
  apiStatus?: string;

  constructor(
    message: string,
    opts?: { statusCode?: number; payload?: unknown; apiStatus?: string }
  ) {
    super(message);
    if (opts?.statusCode !== undefined) this.statusCode = opts.statusCode;
    if (opts?.payload !== undefined) this.payload = opts.payload;
    if (opts?.apiStatus !== undefined) this.apiStatus = opts.apiStatus;
  }
}
